import axios from 'axios';

// Create axios instance
const axiosInstance = axios.create({
  baseURL: 'https://chainfree.info:4000',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - adds token to every request
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - handles token expiration
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // If token is invalid/expired (401), log user out
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('userData');
      window.location.href = '/'; // Redirect to home or login
    }
    
    return Promise.reject(error);
  }
);

export default axiosInstance;